import { Reducer } from "redux";
import { ExerciseState, TExercise } from "./@types";
import { TAction } from "loop-front";
import { OExercise } from "./Model";
import utilities from "../../Resources/Utils";

export const Exercises: Reducer<ExerciseState, TAction> = (state: ExerciseState = {}, action: TAction) => {
    switch (action.type) {
        case OExercise.Actions.LIST_RECEIVED: return { ...state, mainList: action.data }

        // eslint-disable-net-line no-fallthrough
        case OExercise.Actions.POST_ITEM_SUCCESS:
        case OExercise.Actions.PUT_ITEM_SUCCESS:
            return { ...state, mainList: utilities.updateItemList(state.mainList || [], action.data, 'PUT') }

        case OExercise.Actions.ACTIVITY_POST_SUCCESS: {
            switch (action.activity) {
                case OExercise.Activities.TOGGLE_PUBLISH: return { ...state, mainList: utilities.updateItemList(state.mainList || [], action.data, 'PUT') }
                default: return state;
            }
        }

        case OExercise.Actions.ITEM_DELETED: return { ...state, mainList: utilities.updateItemList(state.mainList || [], { id: action.additionalDispatchData.deletedItemId } as TExercise, 'DELETE') }

        default: return state;
    }
}